// Le due sole SOA ufficiali. Tenere allineato a backend/src/utils/soa.js,
// dove ogni valore in scrittura viene ricondotto a una di queste due forme.
export const SOA_OPTIONS = ['LA SOATECH GROUP SPA', 'SOA MEDITERRANEA SPA'];
export const SOA_DEFAULT = SOA_OPTIONS[0];
